<tec-tile
    type="status"
    [title]="`GENERAL.DEVICE_NOT_ALLOWED.TITLE_ONLY_${generalConfig?.allowed_device?.includes('mobile') ? 'MOBILE' : 'PC'}` | translate"
    [subtitle]="`GENERAL.DEVICE_NOT_ALLOWED.DESCRIPTION_ONLY_${generalConfig?.allowed_device?.includes('mobile') ? 'MOBILE' : 'PC'}` | translate"
    tagIconStatus="default"
    icon="icon-alert"
>
    <tec-qr [url]="auth.getQRUrl()" [copyLabel]="'GENERAL.BUTTON.COPY_LINK' | translate">
        <tec-link [size]="'sm'" [label]="auth.getQRUrl()" [href]="auth.getQRUrl()" target="_blank">
            <tec-icon name="icon-external-link" size="xs" />
        </tec-link>
    </tec-qr>
</tec-tile>
